export default {
 
    isMercadoLibreConnected: (state) => state.conectado,
    isMercadoLibrePending: (state) => state.mercadoPending,
    mercadoAuth:             (state) => state.mercadoAuth,
    mercadoProductStatus:    (state) => state.mercadoProductStatus,
    mercadoCategoryPrediction:(state) => state.mercadoCategoryPrediction,
    mercadoCategories:       (state) => state.mercadoCategories,
    mercadoCategoryAttributes:(state) => state.mercadoCategoryAttributes,
    mercadoPublishing:       (state) => state.mercadoPublishing,
    mercadoPublishError:     (state) => state.mercadoPublishError,
    mercadoListingTypes:     (state) => state.mercadoListingTypes,
 
    mercadoProductPrices:    (state) => state.mercadoProductPrices,
    mercadoLoadingPrices:    (state) => state.mercadoLoadingPrices,

    mercadoAvailableItems:        (state) => state.mercadoAvailableItems,
    mercadoAvailableItemsPaging:  (state) => state.mercadoAvailableItemsPaging,
    mercadoAvailableItemsLoading: (state) => state.mercadoAvailableItemsLoading,
    mercadoLinkedItem:            (state) => state.mercadoLinkedItem,
    mercadoLinkedItemLoading:     (state) => state.mercadoLinkedItemLoading,
    mercadoIncident: (state) => state.mercadoIncident,
    mlTransfers:        (state) => state.mlTransfers,
    mlTransfersLoading: (state) => state.mlTransfersLoading,
    mlTransfersParams:  (state) => state.mlTransfersParams,
    
}
 


// WEBPACK FOOTER //
// ./src/modules/mercado-api/getters.js